//エラー時にクラス名を付与する
$(".p-form__itemInner").each(function() {
 if ($(this).find("span.error").length == 1) {
 $(this).addClass("is-error");
 }
});

